import React from 'react';
import { Toaster } from 'react-hot-toast';
import { QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from '../auth/feature/auth';
import { LoaderProvider } from '../common/feature/loader';
import { queryClient } from './queryClient';

export const Providers = ({ children }: { children: JSX.Element }) => (
  <QueryClientProvider client={queryClient}>
    <LoaderProvider>
      <AuthProvider>{children}</AuthProvider>
    </LoaderProvider>
    <Toaster position="top-right" reverseOrder />
  </QueryClientProvider>
);
